import type { ListBuilderList } from '../../../types';

/**
 * Bad Standing list — licenses matched to a Cancelled/Revoked/Suspended
 * registry record (PD-13949). A confirmed match to a dead state license is
 * risk, not coverage: these clients look "matched" but the state board says
 * the license is no longer valid.
 *
 * Backed by the locked `licenseRegistryStanding: bad_standing` filter, which
 * reads the locally-mirrored `client_license.registry_status` column (kept
 * fresh on confirm and by the nightly registry-value re-apply) — tenant-local
 * per PD-13891, and the same predicate as the dashboard's Bad Standing KPI so
 * the click-through count matches the card.
 *
 * Default sort is the `recent-sale-desc` tableSort: clients with the most
 * recent sales activity first — an actively-buying client holding a dead
 * license is the biggest compliance risk (Chris, 2026-07-08).
 */
export const badStandingList: ListBuilderList = {
	id: 'default-licenses-bad-standing',
	cacheTTL: 300000,
	name: 'Bad Standing',
	type: 'default',
	active: true,
	sortOrder: 5,
	filterRules: {
		licenseRegistryStanding: {
			defaultValue: {
				id: 'bad_standing',
				label: 'Bad Standing (Cancelled / Revoked / Suspended)',
			},
			locked: true,
			hidden: true,
		},
		licenseSalesRep: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			applyDefaultIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
		},
	},
	defaultSortId: 'recent-sale-desc',
	inheritsFrom: 'default-licenses-all',
};
